<div class="wrapper-reponsive">
    <div class="tlt-green-row mt-3">
        {{'STR_USER_INFO_MANAGE' | translate}}
    </div>
    <div class="content-box mt-2 mb-2">
        <p class="p-2">
            {{'STR_USER_INFO_NOTE' | translate}}
        </p>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_NAME' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input type="text" id="inpName" (input)="RemoveCommon('Name')" autocomplete="off" autocorrect="off" [(ngModel)]="personalInf.Name" class="form-control" maxlength="80">
                <span *ngIf="objErrorRequire.Name.isError && isValidationError" class="text-error">{{GetMsg(objErrorRequire.Name)}}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2" *ngIf="CheckKana()">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_KANA_NAME' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input type="text" id="inpKanaName" (input)="RemoveCommon('KanaName')" autocomplete="off" autocorrect="off" [(ngModel)]="personalInf.KanaName" [placeholder]="trans.instant('STR_KANA_NAME_PLACEHOLDER')" maxlength="80" class="form-control">
                <span *ngIf="objErrorRequire.KanaName.isError && isValidationError" class="text-error">{{GetMsg(objErrorRequire.KanaName)}}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_DATEOFBIRTH' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <app-date-inp [strId]="'inpDateOfBirth'" (eInp)="RemoveCommon('DateOfBirth')" [strDate]="personalInf.DateOfBirth" (eRemove)="RemoveDOB()" (evReturn)="ChangeDOB($event)"></app-date-inp>
                <span *ngIf="objErrorRequire.DateOfBirth.isError && isValidationError" class="text-error">{{GetMsg(objErrorRequire.DateOfBirth)}}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_GENDER' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <div class="row mt-2">
                    <div class="col-4">
                        <label class="custom-radio">{{'STR_GENDER_MALE' | translate}}
                            <input type="radio" id="rdoGender" (input)="RemoveCommon('DOD')" [(ngModel)]="personalInf.Gender" name="rdoGender" value="1" [checked]="personalInf.Gender==='1'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="custom-radio">{{'STR_GENDER_FEMALE' | translate}}
                            <input type="radio" [(ngModel)]="personalInf.Gender" name="rdoGender" value="2" [checked]="personalInf.Gender==='2'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <span *ngIf="objErrorRequire.Gender.isError && isValidationError" class="text-error">{{GetMsg(objErrorRequire.Gender)}}</span>
                </div>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_PHONENUM' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <app-phone-number [strId]="'inpPhoneNum'" [isError]="isValidationError && objErrorRequire.PhoneNum.isError" [length]="15" [inValue]="personalInf.PhoneNum" (newItemEvent)="SetValue($event, 'PhoneNum')"></app-phone-number>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_ADDRESS' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <!-- 20250120 #18640 modify start -->
                <!-- <input maxlength="11" postalForm numberForm (keypress)="util.numberOnly($event)" id="inpPostalCode" (input)="RemoveCommon('PostalCode')" type="text" autocomplete="off" autocorrect="off" [(ngModel)]="personalInf.PostalCode" class="form-control d-inline-block w200 mr-2"> -->
                <!-- <input maxlength="7" postalForm numberForm (keypress)="util.numberOnly($event)" id="inpPostalCode" (input)="RemoveCommon('PostalCode')" type="text" autocomplete="off" autocorrect="off" [(ngModel)]="personalInf.PostalCode" class="form-control d-inline-block w200 mr-2"> -->
                <!-- 20250208 #18640 modify start -->
                <input maxlength="11" postalForm numberForm (keypress)="util.numberOnly($event)" id="inpPostalCode" (input)="RemoveCommon('PostalCode')" type="text" autocomplete="off" autocorrect="off" [(ngModel)]="personalInf.PostalCode" class="form-control d-inline-block w200 mr-2">
                <!-- 20250208 #18640 modify end -->
                <!-- 20250120 #18640 modify end -->
                <button class="btn-search-green mb-2" (click)="SearchAddress()">
                    <img src="../../../../../assets/img/icon_search.png" alt="">
                </button>
                <div>
                    <span *ngIf="objErrorRequire.PostalCode.isError && isValidationError" class="text-error mt-0 mb-3">{{GetMsg(objErrorRequire.PostalCode)}}</span>
                </div>
                <app-inp-postal-code [idInp]="inpAddress" [isError]="isValidationError && objErrorRequire.Adress1.isError" [maxLength]="maxLength" [data]="lstPostal" (outPostal)="SetValue($event, 'Adress1')"></app-inp-postal-code>
                <input type="text" id="inpAdress2" autocomplete="off" autocorrect="off" [(ngModel)]="personalInf.Adress2" [placeholder]="trans.instant('STR_NEXT_ADDRESS_PLACEHOLDER')" maxlength="255" class="form-control mt-2">
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <ul class="lst-item-border">
                <li>
                    <div class="tlt-dot mb-1">{{'STR_EMAIL_ADDRESS' | translate}}
                    </div>
                    <p class="p-2">
                        {{'STR_UPDATE_EMAIL_NOTE'| translate}}<br>
                        {{'STR_REQUIRE_AUTHENTICATION_EMAIL'| translate}}<br>
                        {{'STR_INTRODUCE_AUTHENTICATION_EMAIL'| translate}}
                    </p>
                </li>
                <li>
                    <div class="mb-1">
                        <b>【{{'STR_CURRENT_EMAIL'| translate}}】</b>
                    </div>
                    <div class="pl-3">
                        <p class="p-2">
                            {{personalInf.MailAdress}}
                        </p>
                    </div>
                </li>
                <li>
                    <div class="mb-1">
                        <b>【{{'STR_NEW_EMAIL'| translate}}】</b>
                    </div>
                    <div class="pl-3">
                        <input type="text" id="inpNewMail" (input)="RemoveUnCommon('NewMail')" (keyup)="ToLowerCase()" maxlength="255" autocomplete="nope" autocorrect="off" [(ngModel)]="personalInf.TemporaryEmailAddress" class="form-control">
                        <span *ngIf="objMess.NewMail.isErr" class="text-error">{{GetMsg(objMess.NewMail)}}</span>
                        <input type="text" id="inpRetypeEmail" (input)="RemoveUnCommon('RetypeEmail')" (keyup)="ToLowerCase()" maxlength="255" autocomplete="nope" autocorrect="off" [(ngModel)]="strNewEmail" [placeholder]="trans.instant('STR_CONFIRM_PASSWORD_PLACEHOLDER')" class="form-control mt-2">
                        <span *ngIf="objMess.RetypeEmail.isErr" class="text-error">{{GetMsg(objMess.RetypeEmail)}}</span>
                    </div>
                    <div class="lst-button mt-2 text-right">
                        <button class="btn btn-bg-red" (click)="CheckEmail()">
                            {{'STR_SEND_VERIFY_EMAIL'| translate}}
                        </button>
                    </div>
                </li>
                <li>
                    <div class="mb-1">
                        <b>【{{'STR_CONFIRM_CODE'| translate}}】</b>
                    </div>
                    <div class="lst-inp-code">
                        <input [type]="disableIME[0]" id="inpCert1" (input)="InputCert($event, 'Cert1', 'VerifyCode')" (focusout)="fcoNumber(txt1, 0)" (focus)="fcNumber($event, 0)" (keyup)="numberOnly($event, 'Cert2')" autocomplete="off" autocorrect="off" maxlength="1" min="0" max="9" numberOnly class="form-control">
                        <input [type]="disableIME[1]" id="inpCert2" (input)="InputCert($event, 'Cert2', 'VerifyCode')" (focusout)="fcoNumber(txt2, 1)" (focus)="fcNumber($event, 1)" (keyup)="numberOnly($event, 'Cert3')" autocomplete="off" autocorrect="off" maxlength="1" min="0" max="9" numberOnly  class="form-control">
                        <input [type]="disableIME[2]" id="inpCert3" (input)="InputCert($event, 'Cert3', 'VerifyCode')" (focusout)="fcoNumber(txt3, 2)" (focus)="fcNumber($event, 2)" (keyup)="numberOnly($event, 'Cert4')" autocomplete="off" autocorrect="off" maxlength="1" min="0" max="9" numberOnly  class="form-control">
                        <input [type]="disableIME[3]" id="inpCert4" (input)="InputCert($event, 'Cert4', 'VerifyCode')" (focusout)="fcoNumber(txt4, 3)" (focus)="fcNumber($event, 3)" (keyup)="numberOnly($event)" autocomplete="off" autocorrect="off" maxlength="1" min="0" max="9" numberOnly class="form-control">
                        <div style="width: 100%;">
                            <span *ngIf="objMess.VerifyCode.isErr && isValidationError" class="text-error">{{GetMsg(objMess.VerifyCode)}}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-4">
            <ul class="lst-item-border">
                <li>
                    <div class="tlt-dot mb-1">{{'STR_PASSWORD' | translate}} 
                    </div>
                    <p class="p-2">
                        {{'STR_UPDATE_EMAIL_NOTE'| translate}}<br>
                        {{'STR_REQUIRE_CURRENT_PASSWORD'| translate}}<br>
                        {{'STR_PASSWORD_NOTE'| translate}}
                    </p>
                </li>
                <li>
                    <div class="mb-1">
                        <b>【{{'STR_CURRENT_PASSWORD'| translate}}】</b>
                    </div>
                    <div class="pl-3">
                        <input type="password" id="inpPassword" maxlength="16" autocomplete="new-password" autocorrect="off" [(ngModel)]="passObj.PassWord" (keyup)="noSpace($event)"
                         (input)="MaskPass($event, 'PassWord')" (paste)="onPaste($event, 'PassWord')" class="form-control mt-2">
                        <span *ngIf="objMess.CurrentPass.isErr" class="text-error">{{GetMsg(objMess.CurrentPass)}}</span>
                    </div>
                </li>
                <li>
                    <div class="mb-1">
                        <b>【{{'STR_NEW_PASSWORD'| translate}}】</b>
                    </div>
                    <div class="pl-3">
                        <input type="password" id="inpNewPass" maxlength="16" autocomplete="new-password" autocorrect="off" [(ngModel)]="passObj.NewPass" (keyup)="noSpace($event)"
                        (input)="MaskPass($event, 'NewPass')" (paste)="onPaste($event, 'NewPass')" class="form-control">
                        <span *ngIf="objMess.NewPass.isErr" class="text-error">{{GetMsg(objMess.NewPass)}}</span>
                        <input type="password" id="inpRenewPass" maxlength="16" autocomplete="new-password" autocorrect="off" [(ngModel)]="passObj.ReNewPass" (keyup)="noSpace($event)"
                        (input)="MaskPass($event, 'ReNewPass')" (paste)="onPaste($event, 'ReNewPass')" [placeholder]="trans.instant('STR_CONFIRM_PASSWORD_PLACEHOLDER')" class="form-control mt-2">
                        <span *ngIf="objMess.ReTypePass.isErr" class="text-error">{{GetMsg(objMess.ReTypePass)}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="text-center mt-2">
            <div class="lst-button-flex">
                <button class="btn btn-common btn-bg-yellow ml-1 mr-1 mb-1" (click)="Return()">
                    {{'STR_BTN_BACK'| translate}}
                </button>
                <button class="btn btn-common btn-bg-green ml-1 mr-1 mb-1" [disabled]="!CheckEnable()" (click)="Save()">
                    {{'STR_BTN_REGIS'| translate}}
                </button>
            </div>
        </div>
    </div>
</div>